module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aK5za"))).then(() => module.bundle.root('hEqeo'));